/**
 * Collection Filters
 * ------------------
 * Handles: dropdown toggle, checkbox → URL, clear, reset, UI sync
 * Flow: checkbox change → closeDropdown() → page reload with new URL params
 */

// ─── Init ────────────────────────────────────────────────────────────────────

document.addEventListener("DOMContentLoaded", () => {
  syncCheckboxesFromUrl();
  updateFilterUI();
  updateTotalFilterCount();
  restoreLastOpenDropdown();
  bindOutsideClick();

  // Reset link — clear localStorage before navigating
  // document.getElementById("filter-reset")?.addEventListener("click", () => {
  //   localStorage.removeItem("lastDropdownId");
  // });

  // const hasActiveFilters = window.location.search.includes("filter.");
  // const resetBtn = document.getElementById("filter-reset");
  // if (resetBtn && hasActiveFilters) {
  //   resetBtn.classList.remove("hidden");
  // }
});

// ─── Dropdown ─────────────────────────────────────────────────────────────────

function toggleDropdown(id) {
  const target = document.getElementById("dropdown-" + id);
  if (!target) return;

  const isHidden = target.classList.contains("hidden");

  // Close all first
  document
    .querySelectorAll(".filter-dropdown")
    .forEach((d) => d.classList.add("hidden"));

  if (isHidden) {
    target.classList.remove("hidden");
    localStorage.setItem("lastDropdownId", id);
  } else {
    localStorage.removeItem("lastDropdownId");
  }
}

function closeDropdown(id) {
  const dropdown = document.getElementById("dropdown-" + id);
  if (!dropdown) return;

  dropdown.classList.add("hidden");
  localStorage.removeItem("lastDropdownId");

  // Build URL from all checked checkboxes across all filters
  const params = new URLSearchParams();
  document
    .querySelectorAll(".filter-options input[type='checkbox']:checked")
    .forEach((input) => {
      params.append(input.dataset.param, input.dataset.value);
    });

  const newUrl = params.toString()
    ? `${window.location.pathname}?${params.toString()}`
    : window.location.pathname;

  window.location.href = newUrl;
}

function restoreLastOpenDropdown() {
  const lastId = localStorage.getItem("lastDropdownId");
  if (!lastId) return;

  const dropdown = document.getElementById("dropdown-" + lastId);
  if (dropdown) dropdown.classList.remove("hidden");
}

function bindOutsideClick() {
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".relative")) {
      document
        .querySelectorAll(".filter-dropdown")
        .forEach((d) => d.classList.add("hidden"));
      localStorage.removeItem("lastDropdownId");
    }
  });
}

// ─── Clear / Reset ────────────────────────────────────────────────────────────

function clearFilter(id) {
  const dropdown = document.getElementById("dropdown-" + id);
  if (!dropdown) return;

  const firstCheckbox = dropdown.querySelector(
    "input[type='checkbox'][data-param]",
  );
  if (!firstCheckbox) return;

  const paramName = firstCheckbox.dataset.param;
  const url = new URL(window.location.href);
  url.searchParams.delete(paramName);

  dropdown.classList.add("hidden");
  localStorage.removeItem("lastDropdownId");

  window.location.href = url.toString();
}

// ─── UI Sync ──────────────────────────────────────────────────────────────────

function syncCheckboxesFromUrl() {
  const params = new URLSearchParams(window.location.search);

  document
    .querySelectorAll(".filter-options input[type='checkbox']")
    .forEach((input) => {
      const active = params
        .getAll(input.dataset.param)
        .includes(input.dataset.value);
      input.checked = active;
    });
}

function updateFilterUI() {
  // Sync color swatch active state
  document.querySelectorAll(".color-option").forEach((opt) => {
    const input = opt.querySelector("input");
    opt.classList.toggle("active", !!input?.checked);
  });

  // Sync pill counts
  document.querySelectorAll(".filters-wrapper .relative").forEach((group) => {
    const active = group.querySelectorAll(
      "input[type='checkbox']:checked",
    ).length;
    const pill = group.querySelector(".count");
    if (pill) pill.textContent = active > 0 ? active : "";
  });
}

function updateTotalFilterCount() {
  const total = document.querySelectorAll(
    ".filter-options input[type='checkbox']:checked",
  ).length;
  const counter = document.getElementById("total-filter-count");
  const resetBtn = document.getElementById("filter-reset");

  if (counter) counter.textContent = total;
  if (resetBtn) resetBtn.classList.toggle("hidden", total === 0);
}

// ─── Search within dropdown ───────────────────────────────────────────────────

function filterOptions(input) {
  const filter = input.value.toLowerCase();
  input
    .closest(".filter-dropdown")
    .querySelectorAll(".filter-option")
    .forEach((opt) => {
      opt.style.display = opt.innerText.toLowerCase().includes(filter)
        ? ""
        : "none";
    });
}
